import { CartSelectors } from "@hopper-b2b/checkout";
import { buildNupayState, encodeNupayState } from "../api/checkAuthStatus";
import {
  type GetPaymentMethodsRequest,
  getPaymentMethods,
} from "../api/getPaymentMethods";
import { type PaymentContext, PaymentState } from "../context";

export const fetchPaymentMethodsService = (
  context: PaymentContext,
  _event: unknown
) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const quoteBreakdown = CartSelectors.getQuoteBreakdown({ context });

      const balance = quoteBreakdown?.balance;

      const paymentTotal = balance?.fiat.value;

      // Check for undefined/null, but allow 0 as a valid payment total (e.g., free bookings)
      if (paymentTotal === undefined || paymentTotal === null) {
        const errorMessage = `quoteBreakdown balance is not a valid number: ${JSON.stringify(
          balance
        )}`;
        console.error(errorMessage);
        throw Error(errorMessage);
      }

      const payload: GetPaymentMethodsRequest = {
        amount: {
          amount: paymentTotal,
          currency: balance.fiat.currencyCode || "BRL",
        },
        state: encodeNupayState(buildNupayState()),
      };
      const response = await getPaymentMethods(payload);
      if (response.Response === "Success") {
        resolve(response.value);
      } else {
        reject({ error: response.errors });
      }
    } catch (error) {
      reject({
        error,
      });
    }
  });
